import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { type ControllerRenderProps } from 'react-hook-form/dist/types/controller';

import { Control, type ControlOuterProps } from '@/components/common/Control';
import { TextInput, type TextInputProps } from '@/components/common/input/TextInput';

type FormTextInputProps = ControlOuterProps &
  Omit<TextInputProps, 'state' | keyof ControllerRenderProps> & {
    name: string;
    disabled?: boolean;
  };

export const FormTextInput: FC<FormTextInputProps> = (props) => {
  const { name, label, className, disabled, ...textInputProps } = props;

  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => {
        const { disabled: fieldDisabled, ...fieldProps } = field;

        return (
          <Control className={className} label={label} error={fieldState.error?.message}>
            <TextInput
              state={fieldState.invalid ? 'error' : 'default'}
              disabled={disabled ?? fieldDisabled}
              {...textInputProps}
              {...fieldProps}
            />
          </Control>
        );
      }}
    />
  );
};
